import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RegisterComponentConfig, RegisterForm} from '../../interfaces/register-form.interface';

@Component({
  selector: 'app-urbisoft-register-form',
  templateUrl: './urbisoft-register-form.component.html',
  styleUrls: ['./urbisoft-register-form.component.scss']
})
export class UrbisoftRegisterFormComponent implements OnInit {
  @Output() registerForm: EventEmitter<RegisterForm> = new EventEmitter<RegisterForm>();
  @Output() continueWithGoogle: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() registerConfig: RegisterComponentConfig = {
    title: 'Register',
    emailLabel: 'Email',
    emailPlaceHolder: 'user@user.com',
    passwordLabel: 'Password',
    passwordPlaceHolder: 'Password',
    nameLabel: 'Name',
    namePlaceHolder: 'Name',
    registerButton: 'Register',
    haveAccountSpan: 'Have an account?',
    loginLabel: 'Login',
    loginLink: '',
    continueWithGoogle: 'Continue With Google'
  };

  formGroup: FormGroup;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  public createUser(): void {
    if (!this.formGroup.invalid) {
      const {name, email, password} = this.formGroup.value;
      this.registerForm.emit({name, email, password});
    }
  }

  public continueWithGoogleOnClick(): void {
    this.continueWithGoogle.emit(true);
  }
}
